export const addHyphenToZipCode = (zipCode: string): string => zipCode.replace(/^(\d{5})(\d{3})$/, "$1-$2");
